// extracted by mini-css-extract-plugin
export default {"itemContainer":"ColorPicker_itemContainer__dn9EJ","color":"ColorPicker_color__u6aHk"};